// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"TableActionButton_actionButton__2sZX-","nameLabel":"TableActionButton_nameLabel__2i1lq","actionButtonWrapper":"TableActionButton_actionButtonWrapper__3mfrx"};